import { SetHomeAction } from '@portal/actions/home';
import { SET_HOME } from '~/actions/actionTypes';

const initialState: reducers.HomeReducer = {
  banners: [],
  features: [],
};

const HomeReducer = (
  state = initialState,
  { type, payload }: SetHomeAction
) => {
  switch (type) {
    case SET_HOME:
      state = {
        ...state,
        banners: payload.banners,
        features: payload.features,
      };
      return state;

    default:
      return state;
  }
};

export default HomeReducer;
